import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import Item from './Item';
import AddActivity from "./AddActivity";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, faCalendar } from "@fortawesome/free-solid-svg-icons";
import { formatItemDate } from '../helpers';

const DeliverableMain = styled.div`
							@media (max-width: 991px) {
								padding-top:100px;
								.mobile-title{
									text-align:center;
									margin-bottom:6px;
								}
							}
							.category-outer{
								background: #F5F5F5;
								padding: 20px 40px;
								margin: 20px auto;
							}
							.cat-border{
								border-top:solid 1px #dfdfdf;
								padding-top:15px;
								@media (max-width: 991px) {
									border-top:0px;
								}
							}
							.title{
								color:#000;
                                font-size:14px;
                                font-weight:bold;
                            }
                            .title-box{
                                width:95%;
                                padding:5px;
                                background: #fff;
                            }
                            .mobile-title{
                                padding-right:25px;
                            }
                            .title-box-left{
                                color:#999;
                                float:left;
                                width:80%;
                                padding-top:5px;
                                span{
                                    padding-left:5px;
                                }
                            }
                            .title-box-right{
                                color:#999;
                                float:left;
                                padding-top:5px;
                                font-size:18px;
                            }
                            .clear{
                                clear:both;
                            }
							
`;


const DelivItem = (props) => {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);

    const handleShow = function (event) {
        event.preventDefault();
        setShow(true);
    };


    return (
        <div className="title-box">
            <span className="title">{props.deliverable.name}</span>
            <div className="title-box-left">
                <FontAwesomeIcon icon={faCalendar} />
                <span>{formatItemDate(props.deliverable.finish)}</span>
            </div>
            <div className="title-box-right">
                <a onClick={handleShow} href="#">
                    <FontAwesomeIcon icon={faInfoCircle} />
                </a>
            </div>
            <div className="clear"></div>
            <AddActivity show={show} onHide={handleClose} item={props.deliverable} deliverable={true} />
        </div>
    );
}

export default DelivItem;